module.exports = __webpack_public_path__ + "static/media/toBeDiscussed.98d29f98.svg";